export type MiscCostCategory = 'packaging' | 'supplies' | 'logistics' | 'other';

export const MISC_COST_CATEGORIES: MiscCostCategory[] = [
  'packaging',
  'supplies',
  'logistics',
  'other',
];

// Overhead that no single order can be charged for — a bubble wrap roll, a tape
// pack, a courier pickup fee. Unlike packaging inventory, these never reach an
// order's landed cost; they are only read as a total over a period.
export interface MiscCost {
  id: string;
  description: string;
  amount: number;
  category: MiscCostCategory | null;
  /** ISO date (YYYY-MM-DD) the cost was incurred — not when it was entered. */
  expense_date: string;
  receipt_ref: string | null;
  created_at: string;
  created_by: string | null;
}

export interface MiscCostSummary {
  total: number;
  count: number;
  /** Every category is present, ₹0 included, so the breakdown always adds up. */
  by_category: Record<string, number>;
}

export interface MiscCostsResponse {
  costs: MiscCost[];
  summary: MiscCostSummary;
}
